import React, { useEffect } from 'react';
import { objectCopy } from 'shared/helpers/general';
import Button from '../Button';

function Pagination({data, onPageChange = () => {}, perPage = 20}) {
   
     const [currentPage, setCurrentPage] = React.useState(1)
     const totalItems = data.length
     const totalPages = Math.ceil(totalItems / perPage)
   
     const items = objectCopy(data).slice((currentPage - 1) * perPage, currentPage * perPage)
   
     const handlePageChange = (page) => {
       if (page >= 1 && page <= totalPages) {
         setCurrentPage(page)
          onPageChange(page)
       }
     }


    return (
        totalPages > 1 && <div className="flex items-center justify-center mt-4 space-x-2">
          <Button
            size="small"
            variant="secondary"
            rounded
            disabled={currentPage === 1}
            onClick={() => handlePageChange(currentPage - 1)}
          >
            Prev
          </Button>
          {/* Pagination numbers with ellipsis */}
          {currentPage > 2 && (
            <>
              <Button
                size="small"
                variant={currentPage === 1 ? "primary" : "secondary"}
                rounded
                onClick={() => handlePageChange(1)}
                className={currentPage === 1 ? "font-bold" : ""}
              >
                1
              </Button>
              {currentPage > 3 && <span className="px-2">...</span>}
            </>
          )}
          {Array.from({ length: totalPages }, (_, i) => i + 1)
            .filter(
              page =>
                page === currentPage ||
                page === currentPage - 1 ||
                page === currentPage + 1
            )
            .map(page => (
              <Button
                key={page}
                size="small"
                variant={currentPage === page ? "primary" : "secondary"}
                rounded
                onClick={() => handlePageChange(page)}
                className={currentPage === page ? "font-bold" : ""}
              >
                {page}
              </Button>
            ))}
          {currentPage < totalPages - 1 && (
            <>
              {currentPage < totalPages - 2 && <span className="px-2">...</span>}
              <Button
                size="small"
                variant={currentPage === totalPages ? "primary" : "secondary"}
                rounded
                onClick={() => handlePageChange(totalPages)}
                className={currentPage === totalPages ? "font-bold" : ""}
              >
                {totalPages}
              </Button>
            </>
          )}
          <Button
            size="small"
            variant="secondary"
            rounded
            disabled={currentPage === totalPages}
            onClick={() => handlePageChange(currentPage + 1)}
          >
            Next
          </Button>
        </div>
    );
}

export default Pagination;